import { SwipeableDrawer } from '@mui/material'

// Types
import type { DrawerProps } from '@/types/components/organisms/drawer'

const DrawerOrganism = (props: DrawerProps) => {
	// Props
	const { open, setOpen, sx, children } = props

	return (
		<SwipeableDrawer anchor="right" keepMounted open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)} sx={sx}>
			{children}
		</SwipeableDrawer>
	)
}

export default DrawerOrganism
